
var countDownDate = new Date("Oct 31, 2023 23:00:00").getTime();
var secondsID = document.getElementById("countdownSeconds");
var minutesID = document.getElementById("countdownMinutes");
var hoursID = document.getElementById("countdownHours");
var daysID = document.getElementById("countdownDays");

var x = setInterval(function() {
  var now = new Date().getTime();

  var distance = countDownDate - now;
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
  secondsID.innerHTML = seconds;
  minutesID.innerHTML = minutes;
  hoursID.innerHTML = hours;
  daysID.innerHTML = days;
}, 1000);

const swiper = new Swiper('.swiper', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: true,

  navigation: {
    nextEl: '.ppz-slide-next',
    prevEl: '.ppz-slide-prev',
  },

  breakpoints: {
    768: {
      slidesPerView: 5,
      spaceBetween: 40
    }
  }
});

function updateCurrentText() {
  console.log("prev");
}

var peepzName = document.getElementById("PeepzName");
swiper.on('slideChangeTransitionStart', function () {
  var currentSlide = document.getElementsByClassName("swiper-slide-active")[0];
  peepzName.innerHTML = currentSlide.dataset.name;
});

var caseWrapper = document.getElementById("openCase");
var caseTitle = document.getElementById("caseTitle");
var caseFigure = document.getElementById("caseFigure");
var caseKendetegnDesc = document.getElementById("caseKendetegnDesc");
var caseBedstevenDesc = document.getElementById("caseBedstevenDesc");
var caseKendtDesc = document.getElementById("caseKendtDesc");
var caseFanAf = document.getElementById("caseFanAf");
var caseFanDesc = document.getElementById("caseFanDesc");
var currentCaseNumber;
var currentCase;

function setCase(theBox) {
  if (currentCase && currentCase.classList.contains("active-box")) {
    currentCase.classList.remove("active-box");
  }
  theBox.classList.add("active-box");
  caseTitle.innerHTML = theBox.dataset.name;
  caseFigure.src = theBox.dataset.figure;

  caseKendetegnDesc.innerHTML = theBox.dataset.kendetegn;
  caseBedstevenDesc.innerHTML = theBox.dataset.bedsteven;
  caseKendtDesc.innerHTML = theBox.dataset.kendtaf;
  caseFanAf.innerHTML = theBox.dataset.fanaf;
  caseFanDesc.innerHTML = theBox.dataset.fan;

  if (!caseWrapper.classList.contains("case-active")) {
    caseWrapper.classList.add("case-active");
  }

  caseWrapper.scrollIntoView({behavior: 'smooth'}, true);
  currentCase = theBox;
  currentCaseNumber = theBox.id.slice(4);
}

function closeCase() {
  if (caseWrapper.classList.contains("case-active")) {
    caseWrapper.classList.remove("case-active");
    currentCase.classList.remove("active-box");
    document.getElementById("ppzCasesShowcase").scrollIntoView({behavior: 'smooth'}, true);
  }
}

function nextCase() {
  if (!caseWrapper.classList.contains("case-active")) {
    return;
  }

  var caseId;
  var oldID = Number(currentCaseNumber);

  if (oldID === 10) {
    oldID = 0
  }
  oldID += 1
  caseId = "case" + oldID;
  
  setCase(document.getElementById(caseId));

  caseId = "";
}

function prevCase() {
  if (!caseWrapper.classList.contains("case-active")) {
    return;
  }

  var caseId;
  var oldID = Number(currentCaseNumber);

  if (oldID === 1) {
    oldID = 11
  }

  oldID -= 1
  caseId = "case" + oldID;
  
  setCase(document.getElementById(caseId));

  caseId = "";
}

var newsmodal = document.getElementById("newsmodal");
function modaleToggler() {
  if (newsmodal.classList.contains("active")) {
    newsmodal.classList.remove("active");
  } else {
    newsmodal.classList.add("active");
  }
}
